<template>
    <div class="products" v-if="images.length && texts.length">
        <div id="carouselIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div :class="['carousel-item', { active: i == 0 }]" v-for="(item, i) in images" :key="i">
                    <img :src="isMobile ? imagesMobile[i] : item" class="d-block" :alt="`Slider_${i}`" />

                    <div class="carousel-caption d-flex flex-column align-items-center align-items-md-start justify-content-center">
                        <div class="carousel-caption-title text-md-start mb-5" v-html="texts[i]"></div>

                        <router-link :to="{ path: '/dc-power-distribution', query: { view: 'all' }}">
                            <b-button variant="primary" class="btn-trimm-wide" pill>{{ $t('ourProducts') }}</b-button>
                        </router-link>

                        <div class="carousel-indicators">
                            <button v-for="(item, inx) in images"
                                    :key="inx"
                                    type="button"
                                    data-bs-target="#carouselIndicators"
                                    :data-bs-slide-to="inx"
                                    :class="['carousel-indicators-btn', { active: inx == i }]"
                                    aria-current="true"
                                    aria-label="Slide"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Wrapper from "@/components/common/wrapper.vue";
    import { MediaPointConstant } from '@/constants/mediaPoint-constants';
    import { Carousel } from 'bootstrap';

    export default {
        name: "products",

        components: {
            wrapper: Wrapper,
        },

        props: {
            images: {
                type: Array
            },
            texts: {
                type: Array
            },
            imagesMobile: {
                type: Array
            }
        },

        computed: {
            isMobile() {
                return window.innerWidth <= MediaPointConstant.MediaPointMd;
            }
        },

        mounted() {
            //Fixed an issue when carousel didn`t work if we change the route and return back to home page
            let indicator = document.getElementById("carouselIndicators");

            new Carousel(indicator, {
                interval: 5000,
                wrap: true
            });
        }
    };
</script>